"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.NEW_PATIENT = exports.ESTABLISHED_PATIENT = exports.DIRECT_BOOK = exports.DEFAULT_PATIENT_REL = void 0;
const NEW_PATIENT = exports.NEW_PATIENT = 'new';
const ESTABLISHED_PATIENT = exports.ESTABLISHED_PATIENT = 'established';
const DEFAULT_PATIENT_REL = exports.DEFAULT_PATIENT_REL = ESTABLISHED_PATIENT;
const DIRECT_BOOK = exports.DIRECT_BOOK = 'direct_book';